export default [
	{
		path: "agenda",
		meta: {
      helpTag: "college:agenda",
    },
    component: () =>
			import(
				"../../views/general/agenda"
			),
			children: [
				{
					path: "",
					name: "College.Agenda",
					component: () =>
						import(
							"../../views/general/agenda/list"
						),
				},
				{
					path: ":hexkey/:ap_hexkey([a-z0-9]{32})?",
					name: "College.Agenda.Details",
					component: () =>
						import(
							"../../views/general/agenda/agenda.vue"
						),
				},
			],
  },
  {
    path: "agenda/:hexkey",
    meta: {
      helpTag: "college:agendavideo"
    },
    component: () => import("../../views/council-public/agendavideo"),
    children: [
      {
        path: "vod/:ap_hexkey?",
        name: "College.AgendaVideo.VOD",
        component: () =>
          import(
            "../../views/council-public/agendavideo/vod"
          ),
      },
      {
        path: "live",
        name: "College.AgendaVideo.Live",
        component: () =>
          import(
            "../../views/council-public/agendavideo/live"
          ),
      },
    ],
  },
];